import { t } from 'i18next';
import { Button } from '../common/Button';
import Model from '../common/models/Model';
import { useDeleteBrandUser } from '@/hooks/queries/useUserQueries';
import { toast } from 'react-toastify';

interface DeactivateUserProps {
  isDeleteModalOpen: boolean;
  setIsDeleteModalOpen: (arg: boolean) => void;
  userStatus: string;
  userName: string;
  userId: string;
  onSuccess: () => void;
  setIsLoading: (arg: boolean) => void;
}

const DeleteUserModal: React.FC<DeactivateUserProps> = ({
  isDeleteModalOpen,
  setIsDeleteModalOpen,
  userName,
  userId,
  onSuccess,
  setIsLoading,
}) => {
  const deleteMutation = useDeleteBrandUser();

  const handleDeleteUser = async () => {
    setIsLoading(true);
    setIsDeleteModalOpen(false);
    try {
      await deleteMutation.mutateAsync(userId);
      toast.success(t('userManagement.userDeletedSuccess'));
      onSuccess();
    } catch (error) {
      toast.error(t('errors.actionFailed'));
    }
  };
  return (
    <Model
      isOpen={isDeleteModalOpen}
      onClose={() => setIsDeleteModalOpen(false)}
      className="backdrop-brightness-75"
    >
      <div className="md:w-[360px]">
        <h1 className="text-2xl font-header text-[#212121]">
          {t('userManagement.actions.deleteUser')}
        </h1>
        <p className="my-4 text-gray-600">
          {t('userManagement.actionsConfirmationMessage.deleteUser')}
          &nbsp;{userName}?
        </p>
        <div className="mt-6 flex w-full items-center justify-between gap-4">
          <Button
            onClick={() => setIsDeleteModalOpen(false)}
            variant="outlined"
            className="w-[160px] h-[44px] px-0 py-0"
          >
            {t('common.cancel')}
          </Button>
          <Button
            onClick={handleDeleteUser}
            className="w-[160px] h-[44px] px-0 py-0"
          >
            {t('common.delete')}
          </Button>
        </div>
      </div>
    </Model>
  );
};

export default DeleteUserModal;
